module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-23GIU-25BLOG-b419510da44fff4e101d0ea2115289fa.jpg";